import { useEffect as e, useState as t } from "react";
//#region src/hooks/useMobile.ts
var n = {
	mobile: 640,
	tablet: 1024
}, r = () => {
	let r = () => ({
		isMobile: window.innerWidth < n.mobile,
		isTablet: window.innerWidth >= n.mobile && window.innerWidth < n.tablet,
		isDesktop: window.innerWidth >= n.tablet
	}), [i, a] = t(() => typeof window > "u" ? {
		isMobile: !1,
		isTablet: !1,
		isDesktop: !0
	} : r());
	return e(() => {
		let e = () => a(r());
		return window.addEventListener("resize", e, { passive: !0 }), () => window.removeEventListener("resize", e);
	}, []), i;
};
//#endregion
export { r as useMobile };
